module.exports = __webpack_public_path__ + "static/media/PULAR.85ec9a3d.png";